/**
 * @generated SignedSource<<3c33b0ae4e34ef56e1075f259e246d90>>
 * @relayHash 09c0cc6c07ae78116fbd3cbd8c880c1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5aec69753597050a3de61a3a8ecaf0250bb3d1004b26d23f19dcbcd7463ac331

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type browseSkills_UnifiedQuery$variables = {
  after?: string | null;
  cloudId: string;
  first?: number | null;
  searchKeyword?: string | null;
};
export type browseSkills_UnifiedQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef">;
};
export type browseSkills_UnifiedQuery = {
  response: browseSkills_UnifiedQuery$data;
  variables: browseSkills_UnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchKeyword"
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "searchKeyword",
    "variableName": "searchKeyword"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "kind": "ScalarField",
  "name": "iconUrl"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "browseSkills_UnifiedQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "FragmentSpread",
        "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "browseSkills_UnifiedQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "ConvoAiAvailableSkillsResult",
        "kind": "LinkedField",
        "name": "convoai_availableSkills",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiSkillEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiSkill",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "slashCommand"
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "iconKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "color"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "helpText"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "source"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "tags"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "integrationKeys"
                  },
                  {
                    "concreteType": "ConvoAiSkillIntegration",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "version"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
              },
              {
                "kind": "ScalarField",
                "name": "startCursor"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "concreteType": "ConvoAiSkillListMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "anthropicCount"
              },
              {
                "kind": "ScalarField",
                "name": "stratusCount"
              },
              {
                "kind": "ScalarField",
                "name": "isDegraded"
              }
            ]
          },
          {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "filters": [
          "cloudId",
          "searchKeyword"
        ],
        "handle": "connection",
        "key": "browseSkills__convoai_availableSkills",
        "kind": "LinkedHandle",
        "name": "convoai_availableSkills"
      }
    ]
  },
  "params": {
    "id": "5aec69753597050a3de61a3a8ecaf0250bb3d1004b26d23f19dcbcd7463ac331",
    "metadata": {},
    "name": "browseSkills_UnifiedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d8d784ea495ad17459bfaf5cf2b08903";

export default node;
